import React, { useEffect, useState } from 'react'
import { api } from '../../../../../utils'
import { SISTEMIPAGAMENTO } from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import { trackingCheckoutPayment, trackingGAEvent } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'
import { useRouter } from 'next/router'
import * as Sentry from '@sentry/browser'
import { useSelector } from 'react-redux'
import Tooltip from '../../../../atoms/Tooltip/Tooltip'
import { Info } from '../../../../atoms/NewIcons'
import CheckoutOption from '../../../../molecules/CheckoutOption/CheckoutOption'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'

// ! Hardcoded
const opzioni_pagamento = [
  'Codificato Sipec',
  'Carta di credito',
  'Pagamento con Paypal',
  'Bonifico bancario anticipato',
]

// ! Inserire Questo Obj se si vuole testare IBAN
const test_iban = {
  attivo: true,
  codice: '932',
  descrizione:
    'Sarai reindirizzato alla pagina del nostro circuito di pagamento per inserire i tuoi dati della carta e confermare lâ€™ordine.',
  iban: '432493280943240003243423',
  id: 1,
  nome: 'Carta di credito',
}

const ModalitaPagamento = ({ props, step, setStep, carrello_main, Submit }) => {
  const [selectPagamento, setSelectPagamento] = useState(props.values.id_modalita_pagamento)
  const [opzioniPagamento, setOpzioniPagamento] = useState([])
  const [Loading, setLoading] = useState(false)
  const metodiPagamento = opzioniPagamento
  const router = useRouter()
  const t = useTrans()
  const { service_gift } = useSelector((state) => state?.servicegift)
  const { utente } = useSelector((state) => state.utente)

  useEffect(() => {
    selectPagamento && props.setFieldValue('id_modalita_pagamento', selectPagamento)
  }, [selectPagamento])

  useEffect(() => {
    setLoading(true)
    api
      .get(SISTEMIPAGAMENTO, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => {
        const newOpzioniPagamento = res?.data || []
        setOpzioniPagamento(newOpzioniPagamento)
        props.setFieldValue('opzioni_pagamento', newOpzioniPagamento)
        if (
          !props.values?.id_modalita_pagamento &&
          newOpzioniPagamento.find((x) => x.id === utente.sistema_pagamento)
        ) {
          setSelectPagamento(
            newOpzioniPagamento?.find((x) => x.id === utente.sistema_pagamento)?.id || null
          )
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
        Sentry.captureException(err)
      })
  }, [])

  return Loading ? (
    <LoadingSvg />
  ) : (
    <div className="checkout__pagamento">
      {!service_gift && (
        <FormField
          status={props.errors.codice_sconto && 'error'}
          errorMessage={props.touched.codice_sconto && props.errors.codice_sconto}
          label={
            <>
              {t('Codice sconto')}
              <span className="checkout__pagamento__codice-sconto__info">
                <Tooltip
                  label={t('Inserisci il codice promozionale per applicare lo sconto')}
                  id="codice-sconto-tooltip"
                  size="sm"
                >
                  <Info />
                </Tooltip>
              </span>
            </>
          }
          className="checkout__formfield"
        >
          <FormInput
            onBlur={props.handleBlur('codice_sconto')}
            value={props.values.codice_sconto}
            placeholder={t('Inserisci codice')}
            onChange={(e) => props.setFieldValue('codice_sconto', e.target.value)}
          />
          <div className="checkout__pagamento__codice-sconto__alert">
            <p>
              {t('Attenzione: lo sconto verrà applicato dopo la conferma del metodo di pagamento')}
            </p>
          </div>
        </FormField>
      )}
      <FormField className="checkout__formfield">
        {opzioniPagamento.length > 0 &&
          opzioniPagamento.map((opzione) => (
            <CheckoutOption
              title={opzione?.nome || opzione?.descrizione}
              description={!opzione?.nome ? null : opzione?.descrizione}
              moreContent={
                <>
                  {opzione?.iban && (
                    <p className="checkout__pagamento__more-content">
                      <strong>IBAN:</strong> {opzione.iban}
                    </p>
                  )}
                </>
              }
              checked={selectPagamento === opzione.id}
              onClick={() => setSelectPagamento(opzione.id)}
              fullClick
              key={opzione.id}
            />
          ))}
      </FormField>

      {selectPagamento !== null &&
        utente.sistema_pagamento != props.values.id_modalita_pagamento && (
          <FormField className="checkout__formfield">
            <FormCheckbox
              label={t('Usa come predefinito il metodo di pagamento selezionato')}
              onChange={() =>
                props.setFieldValue(
                  'id_modalita_pagamento_predefinita',
                  !props.values.id_modalita_pagamento_predefinita
                )
              }
              checked={props.values.id_modalita_pagamento_predefinita}
              onBlur={props.handleBlur('id_modalita_pagamento_predefinita')}
            />
          </FormField>
        )}
      {selectPagamento !== null && (
        <Button
          disabled={props.isValid ? false : true}
          label={t('Conferma pagamento')}
          variant="primary"
          size="medium"
          onClick={() => {
            const pagamentoSelezionato = opzioniPagamento?.find((p) => p.id === selectPagamento)
            trackingCheckoutPayment(carrello_main, pagamentoSelezionato?.nome ?? pagamentoSelezionato?.descrizione, props?.values?.codice_sconto)
            setStep(step + 1)
            let payMethod = ''
            metodiPagamento.forEach((metodo) => {
              if (metodo.id == selectPagamento) payMethod = metodo.nome
            })
            Submit()
          }}
        />
      )}
    </div>
  )
}

export default ModalitaPagamento
